module.exports = __webpack_public_path__ + "img/eye.d44215b4.svg";